<template>
    <div class="IperMatrizPeligrosCentroTrabajo">
        {{ centroTrabajo }}
    </div>
</template>

<script>
export default {
    name: "IperMatrizPeligrosCentroTrabajo",

    props: {
        centroTrabajo: String
    }
}
</script>